import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import ko from './locales/ko/translation.json';
import es from './locales/es/translation.json';
import de from './locales/de/translation.json';

export const SUPPORTED_LANGUAGES = ['en', 'ko', 'es', 'de'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    defaultNS: 'translation',
    resources: {
      en: { translation: en },
      ko: { translation: ko },
      es: { translation: es },
      de: { translation: de },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'clearlab.lang',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export default i18n;
